import { IProduct } from '@v2/interfaces';
import { useEffect, useState } from 'react';
import Loader from '../presentational/loader/loader';
import ProductModal from './product';

export default function ProductModalWithPromise({ promise, disabled, playVideo, isNewBox, hide }
    : { promise: Promise<IProduct>, disabled?: boolean, playVideo?: boolean, isNewBox?: boolean, hide?: Function }
) {
    const [product, setProduct] = useState(null);

    useEffect(() => {
        promise.then(setProduct);
    }, []);

    return product
                ? <ProductModal
                    product={product}
                    disabled={disabled}
                    playVideo={playVideo}
                    isNewBox={isNewBox}
                    hide={hide} />
                : <Loader style={{marginTop: '35vh'}} />;
}